/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 基本契約詳細情報
 */
export interface Szma301aResBasiccontractDetailsinformationDto {
    /**
     * 基本契約対象年次
     */
    basiccontractTargetyear?: string;
    /**
     * 開始日付
     */
    startDate?: string;
    /**
     * 終了日付
     */
    endDate?: string;
    /**
     * 契約年間最高使用量
     */
    ctrAnnualmaximumEmpamt?: string;
    /**
     * 契約年間最低使用量
     */
    ctrAnnualminimumEmpamt?: string;
}

